// extracted by mini-css-extract-plugin
export default {"root":"spinner_root__C+ROZ","bg_transparent":"spinner_bg_transparent__xQau7","bg_full":"spinner_bg_full__Nhe4H"};